(function () {
  var STYLE_URL = 'https://cdn.shopify.com/s/files/1/0565/7080/6458/t/74/assets/product-art.css?v=1786431990';

  function ensureStyles() {
    if (document.querySelector('link[href*="/assets/product-art.css"]')) return;
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = STYLE_URL;
    stylesheet.setAttribute('data-sale-countdown-styles', '');
    document.head.appendChild(stylesheet);
  }

  function mountFallback() {
    if (document.querySelector('[data-sale-countdown]')) return;
    var template = document.querySelector('template[data-sale-countdown-fallback]');
    var priceSummary = document.querySelector('.ever-price-summary');
    if (!priceSummary) return;
    var productMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    var saleHandles = [
      'sage-green-classic-square-panel-wall-mural-wallpaper',
      'green-misty-forest-mural-wallpaper',
      'enchanted-forest-bath-mural-wallpaper',
      'union-jack-flag-wall-murals',
      'neutral-texture-mural-wallpaper',
      'overlooking-london-photo-murals',
      'colorless-bloom-vintage-flower-mural-idea-room-decor'
    ];
    var handle = productMatch ? productMatch[1] : '';
    if (!priceSummary.classList.contains('is-on-sale') || saleHandles.indexOf(handle) === -1) return;
    ensureStyles();
    var countdown;
    if (template && template.content && template.content.firstElementChild) {
      countdown = template.content.firstElementChild.cloneNode(true);
    } else {
      countdown = document.createElement('div');
      countdown.className = 'ever-sale-countdown';
      countdown.setAttribute('data-sale-countdown', '');
      countdown.setAttribute('aria-label', '30% off sale countdown');
      countdown.innerHTML =
        '<div class="ever-sale-countdown__heading">' +
          '<span class="ever-sale-countdown__badge">30% OFF</span>' +
          '<span class="ever-sale-countdown__title"><i aria-hidden="true"></i>Offer ends in</span>' +
        '</div>' +
        '<div class="ever-sale-countdown__timer" role="timer" aria-live="off">' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-days>00</strong><small>Days</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-hours>00</strong><small>Hrs</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-minutes>00</strong><small>Min</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-seconds>00</strong><small>Sec</small></span>' +
        '</div>';
    }
    priceSummary.classList.add('has-sale-countdown');
    priceSummary.insertAdjacentElement('afterend', countdown);
  }

  function synchronise(countdown) {
    if (countdown.__ewTopbarCountdownSync) return;

    var topbar = document.querySelector('[data-autumn-bar]');
    if (!topbar) {
      countdown.hidden = true;
      return;
    }

    // A store-wide legacy countdown can initialise before this theme script.
    // Replace its node so its old timer only retains references to detached digits.
    if (countdown.getAttribute('data-topbar-countdown-synced') !== 'true') {
      var replacement = countdown.cloneNode(true);
      replacement.setAttribute('data-countdown-initialised', 'true');
      replacement.setAttribute('data-topbar-countdown-synced', 'true');
      countdown.parentNode.replaceChild(replacement, countdown);
      countdown = replacement;
    }

    countdown.__ewTopbarCountdownSync = true;
    countdown.setAttribute('data-countdown-initialised', 'true');

    var sourceClock = topbar.querySelector('[role="timer"]');
    var targetClock = countdown.querySelector('[role="timer"]');
    var unitMap = {
      days: '[data-countdown-days]',
      hours: '[data-countdown-hours]',
      minutes: '[data-countdown-minutes]',
      seconds: '[data-countdown-seconds]'
    };

    function copyTopbarTime() {
      var complete = true;
      Object.keys(unitMap).forEach(function (unit) {
        var source = topbar.querySelector('[data-unit="' + unit + '"]');
        var target = countdown.querySelector(unitMap[unit]);
        if (!source || !target) {
          complete = false;
          return;
        }
        target.textContent = source.textContent;
      });

      var endAt = Date.parse(topbar.getAttribute('data-end-at') || '');
      var active = complete && Number.isFinite(endAt) && endAt > Date.now() && !topbar.hidden;
      countdown.hidden = !active;
      if (active) countdown.setAttribute('data-countdown-ready', 'true');
      else countdown.removeAttribute('data-countdown-ready');

      if (sourceClock && targetClock) {
        targetClock.setAttribute('aria-label', sourceClock.getAttribute('aria-label') || 'Time remaining');
      }
    }

    copyTopbarTime();
    var observer = new MutationObserver(copyTopbarTime);
    observer.observe(topbar, {
      attributes: true,
      attributeFilter: ['hidden', 'data-end-at'],
      childList: true,
      characterData: true,
      subtree: true
    });

    // Covers browser throttling and any third-party script that rewrites the digits.
    window.setInterval(copyTopbarTime, 250);
    document.addEventListener('visibilitychange', copyTopbarTime);
  }

  function start() {
    mountFallback();
    document.querySelectorAll('[data-sale-countdown]').forEach(synchronise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
